import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-24 text-center">
      <h1 className="text-3xl font-extrabold text-brand-navy">Page not found</h1>
      <p className="mt-2 text-gray-500">
        The page you’re looking for doesn’t exist.
      </p>
      <Link
        to="/"
        className="mt-6 inline-block rounded-md bg-brand-blue px-5 py-2.5 font-semibold text-white hover:bg-brand-blue-dark"
      >
        Back to home
      </Link>
    </div>
  );
}
